import { faIdCard, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { Checkbox } from 'components/Checkbox';
import styles from 'pages/Database/Clients/ClientCard/ClientCard.scss';

export const ClientCard = ({
  client: { id, surname, name, debt, balance, subscriptions },
  isHighlighted,
  isSelected,
  isSelectionMode,
  toggleSelection,
}) => {
  const navigate = useNavigate();

  const navigateToClientPage = () => {
    navigate(`${id}`);
  };

  return (
    <button
      className={cn(styles.cardContainer, {
        [styles.selected]: isSelected,
        [styles.selectionMode]: isSelectionMode,
        [styles.highlighted]: isHighlighted,
      })}
      onClick={() => (isSelectionMode ? toggleSelection(id) : navigateToClientPage())}
    >
      <div className={styles.card}>
        <div className={cn(styles.info, { [styles.expanded]: subscriptions?.[0] })}>
          {isSelectionMode && <Checkbox className={styles.checkbox} checked={isSelected} />}
          <div className={styles.name}>
            {surname}
            <br />
            <strong>{name}</strong>
          </div>
        </div>
        {subscriptions?.[0] && (
          <FontAwesomeIcon
            className={cn(styles.subscriptionIcon, {
              [styles.star]: subscriptions[0].type === 'membership',
              [styles.expired]: subscriptions[0].status === 'expired',
            })}
            icon={subscriptions[0].type === 'membership' ? faStar : faIdCard}
          />
        )}
      </div>
      <div className={styles.plates}>
        {!!debt && <div className={cn(styles.plate, styles.debt)}>{debt}₴</div>}
        {!!balance && <div className={cn(styles.plate, styles.balance)}>{balance}₴</div>}
      </div>
    </button>
  );
};
